import { render, staticRenderFns } from "./DefaultPasswordRecoveryInput.vue?vue&type=template&id=434a90ab&lang=pug&"
import script from "./DefaultPasswordRecoveryInput.vue?vue&type=script&lang=ts&"
export * from "./DefaultPasswordRecoveryInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports